import React from 'react';
import OpenDNSBanner from '../../../components/OpenDNSBanner';
import { HeroImageBanner } from '@opendns/opendns-dpl';

const MainPage = () => {
    return (
        <div classnName="mainform-container">
            <section className="cisco-banner">
                <div className="cisco-banner__logo">
                    <a href="http://www.cisco.com/" target="_blank">
                        <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/Cisco_Logo_RGB_Screen_White.png" className="cisco-banner__logo__img cisco-banner__logo__img--light" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                        <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/cisco-dark-logo.png" className="cisco-banner__logo__img cisco-banner__logo__img--dark" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                    </a>
                </div>
                <div className="cisco-banner__learn">
                    <p>
                        <span>OpenDNS is now part of Cisco</span>
                        <a href="http://www.cisco.com/web/about/ac49/ac0/ac1/ac259/opendns.html" target="_blank" className="cisco-banner__learnLink">
                            <span>Learn More </span>
                            <i className="fa fa-caret-right"></i>
                        </a>
                    </p>
                </div>
                <div className="cisco-banner__about">
                    <a href="http://www.cisco.com/web/about/index.html" target="_blank">About Cisco</a>
                </div>
            </section>

            <OpenDNSBanner />

            <HeroImageBanner
                size="small"
                imageUrl="/images/Premium-DNS-Hero-Full-Page.png"
            >
                <h1 className="hero-banner__heading">Premium DNS is now DNS Monitoring</h1>
            </HeroImageBanner>

            <div className="grid">
                <div className="main-column">
                    <h2>To sign up for DNS Monitoring, visit our <a href="https://dnsmonitoring.umbrella.com">signup page</a>.</h2>
                    <p>
                        DNS Monitoring is a free recursive DNS service designed to provide businesses with real-time security visibility.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MainPage;



// WEBPACK FOOTER //
// ./src/premiumdns/js/partials/MainPage.js